import React from 'react';
import { Box } from '@osmosis/react-ui/components/Box';
import { Tooltip } from '@osmosis/tailwind-ui/components/tooltip/Tooltip';
import { getColor } from '@osmosis/shared/styles';
import { useQuizContext } from '../../../../context/QuizContext';
import { HotSpotData } from '../../../../types/quiz';

/**
 * Create path for svg <path/>.
 */
export const getPath = (area: { x: string; y: string }[]) => {
  const d = area.reduce((d, point, i) => {
    if (i === 0) {
      return `M${point.x},${point.y}`;
    }

    return `${d} L${point.x},${point.y}`;
  }, '');
  return `${d} Z`;
};

/**
 * Correct area for HotSpot component.
 */
const HotSpotArea = ({ isAnswered }: { isAnswered: boolean }) => {
  const { currentItem } = useQuizContext();

  return (
    <Box
      opacity={isAnswered ? 1 : 0}
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      sx={{
        position: 'absolute',
        top: -1,
        left: 0,
        cursor: 'pointer',
      }}
    >
      <svg viewBox="0 0 500 500" width="100%">
        <g data-tooltip-id="hot-spot-correct-answer">
          <path
            id="hot-spot-area"
            style={{
              fill: getColor('dark', 'positiveLight'),
              stroke: getColor('dark', 'positive'),
              strokeWidth: '2px',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d={getPath((currentItem?.data as HotSpotData).answers.area)}
          />
        </g>
      </svg>
      <Tooltip
        id="hot-spot-correct-answer"
        content="Correct"
        place="top"
        isOpen={isAnswered}
      />
    </Box>
  );
};

export default HotSpotArea;
